import { render, staticRenderFns } from "./ChiefComplaint.vue?vue&type=template&id=f24514de&"
import script from "./ChiefComplaint.vue?vue&type=script&lang=js&"
export * from "./ChiefComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports